import React, { useRef } from "react";
import ListCalendar from "../ListCalendar";
import _ from "underscore";
import Wrapper from "./Wrapper";
import { Macros } from "../../models/Macros";
import { toSearchCriteria } from "../../lib/FilterUtils";
import { FORM_TYPES } from "./PrefsCoreAPI";
import { useObjectSelectMacros } from "../../hooks/useObjectSelectMacros";
import { useAppContext } from "../../contexts/AppContext";
import { TListCalendarWrapperProps } from "../../types/components/ListCalendarWrapper";
import { TComponent } from "../../types/utils";

const findFilter = (reservationData) => {
    if (reservationData.objects) {
        return reservationData.objects.filter((object) => object.fields && !object.id);
    }
    return null;
};

type TPrefsComponentCalendarProps = {
    id: number;
    width?: number;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [];

const PrefsComponentCalendar: TComponent<TPrefsComponentCalendarProps> = (props) => {
    const appContext = useAppContext();
    const wrapper = useRef<HTMLElement | null>(null);
    const { selectType: onTypeSelected, applySearchCriteria: onSearchCriteriaSelected } =
        useObjectSelectMacros("prefsComponent");

    const onObjectSelected = (objects, type) => {
        appContext.fireEvent("prefsComponent", Macros.Event.SELECT_EXTERNAL_OBJECT, {
            objects,
            type,
        });
    };

    const onPopulateSelection = (reservationData, useSpotlight = true, callback = _.noop) => {
        const postType = () => {
            appContext.fireEvent(
                "prefsComponent",
                Macros.Event.SET_EXTERNAL_SELECTION,
                reservationData,
                () => {
                    // Filters are typed fields in reservationData, so onSearchCriteriaSelected or equivalent function needs to be able to set multiple filters
                    const filters = findFilter(reservationData);
                    if (filters && filters.length > 0) {
                        onSearchCriteriaSelected(toSearchCriteria(filters), false, _.noop);
                    }
                    const focusDate = reservationData.begin || reservationData.focusDate;
                    if (focusDate) {
                        appContext.fireEvent(
                            `prefsInCore`,
                            Macros.Event.SET_EXTERNAL_DATE,
                            focusDate,
                            null,
                            useSpotlight
                        );
                    }
                    callback();
                }
            );
        };
        appContext.focusFirstCalendar(false);
        if (reservationData.formType) {
            const type = FORM_TYPES[reservationData.formType] || 1;
            appContext.fireEvent(
                `prefsInCore`,
                Macros.Event.SET_EXTERNAL_TEMPLATE_KIND,
                type,
                () => {
                    postType();
                }
            );
        } else {
            postType();
        }
    };

    const onRequestOperation = (operationType, data = {}, callback = _.noop) => {
        appContext.fireEvent("prefsComponent", Macros.Event.REQUEST_OPERATION, {
            operationType,
            data,
            callback,
        });
    };

    let style: React.CSSProperties = { width: props.width, height: "100%" };
    if (props.style) {
        style = props.style;
    }
    return (
        <ListCalendar
            {...props}
            className={`${props.className} prefsComponent`}
            type={"prefsComponent"}
            refreshEvents={getRefreshEvents()}
            selectType={onTypeSelected}
            selectObject={onObjectSelected}
            setSearchCriteria={onSearchCriteriaSelected}
            populateSelection={onPopulateSelection}
            requestOperation={onRequestOperation}
            privateSelected={false}
            listRef={(node) => {
                wrapper.current = node;
            }}
            fireEvent={appContext.fireEvent}
        >
            <Wrapper style={style} />
        </ListCalendar>
    );
};

export default PrefsComponentCalendar;
